import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Button from '@mui/material/Button';
import { useTheme } from '../../hooks';
import { darkTheme, lightTheme } from '../../theme/materialUiTheme';

const CustomButton = ({ label, fontSize, className, paddingHorizontal, fullWidth, onClick, path, target }) => {
  const useStyles = makeStyles((theme) => ({
    btn: {
      backgroundImage: theme.palette.background.darkBg,
      border: theme.palette.borderType.border1,
      borderColor: theme.palette.border.lightColor,
      // backgroundSize: '200% auto',
      flex: '1 1 auto',
      transition: '0.5s ease',
      borderRadius: '25px',
      fontFamily: 'Kanit',
      paddingX: paddingHorizontal,
      fontSize: fontSize,
      '&:hover': {
        backgroundImage: theme.palette.background.hoverBg,
        backgroundClip: 'unset',
        WebkitBackgroundClip: 'unset',
        textFillColor: 'unset',
        WebkitTextFillColor: 'unset',
        color: theme.palette.text.lightBtn,
        // backgroundPosition: 'right center',
      },
      '&:active': {
        background: theme.palette.background.hoverBg,
      },
    },
    BtnText: {
      color: theme.palette.text.lightBtn,
      background: theme.palette.background.btnText,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      textFillColor: theme.palette.text.textFillColor,
      WebkitTextFillColor: 'transparent',
    },
  }));
  const classes = useStyles();
  const { theme } = useTheme();

  return (
    <>
      <a href={path} target={target}>
        <Button
          className={`${classes.btn} customBtn ${className}`}
          onClick={onClick}
          fullWidth={fullWidth}
          size="small"
          variant="contained"
        >
          <span className={`${classes.BtnText}`}>{label}</span>
        </Button>
      </a>
    </>
  );
};

export default CustomButton;
